import * as globals from '@wandb/common/css/globals.styles';
import {Link} from '@wandb/common/util/links';
import styled, {css} from 'styled-components';

export const ReportPageContainer = styled.div<{isViewMode?: boolean}>`
  display: flex;
  ${props => css`
    ${props.isViewMode && 'flex-direction: column;'}
  `}
`;

export const ReportPageInnerContainer = styled.div`
  width: 100%;
`;

export const FCReportTags = styled.div`
  max-width: 788px;
  margin: 24px auto 0;
  padding: 0 36px;
  color: ${globals.gray600};
`;

export const FCReportTag = styled(Link)`
  &,
  &:hover {
    color: ${globals.gray600};
  }
`;

export const FCReportCTA = styled.div``;
